module.exports = __webpack_public_path__ + "img/undraw_progressive_app.35472ceb.png";